<template>
	<div>
		<div v-show="!minimal" :id="'jsoneditor-' + id"></div>

		<div v-show="!minimal"
			style="
				width: 100%;
				height: 500px;
				display: inline-block;
				position: relative;
			">
			<pre
				style="width: 100%; height: 100%"
				:id="'ace_editor-' + id"></pre>
		</div>

		<!--<form @submit.prevent="getFormValues" v-html="html_form"></form>-->

		<iframe height="500px" width="100%" :srcdoc="'<form host=\'' + host + '\' id=\'form\' token=\'' + token + '\' onsubmit=\'submitForm(event)\'>' + html_form + '<script>' + script_iframe + '</script></form>'" id="preview" sandbox="allow-forms allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-modals"></iframe>

		<div v-if="result">
			<p>Resultats</p>
			<pre>{{ result }}</pre>
		</div>

		<p>Données de test</p>

		<b-select v-model="type_data_test" :options="[
			{value: '',  text: ''},
			{value: 'tabulator', text: 'Tableau'},
			{value: 'database', text: 'Base de données'},
			{value: 'DatabaseRequestView', text: 'Base de données - multitables'},
		]" />

		<br /><br />

		<div v-if="type_data_test == 'tabulator'">
			<edit_tabulator ref="edit_tabulator"></edit_tabulator>
		</div>

		<DatabaseRequestView v-if="type_data_test == 'DatabaseRequestView'"
			_type="db"
			:minimal="true"
			ref="edit_tabulator" />

		<div v-if="type_data_test == 'database'">
			<database
				:change_table="true"
				:name="false"
				:edit="false"
				ref="edit_tabulator"></database>
		</div>

		<b-button @click="update">Mettre à jour</b-button>
	</div>
</template>

<script>
	import "../../public/js/ace-builds/src-min-noconflict/ace.js";
	import "../../public/js/ace-builds/src-min-noconflict/ext-language_tools.js";

	import { JSONEditor } from "@json-editor/json-editor";
	import uniqueId from "lodash.uniqueid";
	import moment from "moment";
	import __ from 'lodash';

	import DatabaseRequestView from '../views/DatabaseRequestView.vue';
	import edit_tabulator from "../components/edit_tabulator.vue";
	import databaseView from "../views/database.vue";
	import users from "../services/users.js";
	import store from "../store";

	require('moment/locale/fr')

	var clone = require("clone");
	const removeAccents = require('remove-accents-diacritics');

	export default {
		name: "create_form",
		components: {
            edit_tabulator,
            DatabaseRequestView,
        	database: databaseView,
		},
		data() {
			return {
				type_data_test: "",
                arr: [],
				
				host: `${process.env.VUE_APP_SAAS_BACK}`,
				ace_editor: null,
				html_form: ``,
				id: uniqueId(""),
				result: "",
				token: store.state.jwt,
				script_iframe: `
    function submitForm(event){
		console.log("a")
		console.log(event)
				
		var data = new FormData(event.target);
		var value = Object.fromEntries(data.entries());

		window.parent.postMessage({type: "form", data: value})
		event.preventDefault();
    }
				`
			};
		},
		props: {
			minimal: {
				default: false
			}
		},
		methods: {
			receiveMessage (event) 
			{
				if (event.data && event.data.type == "form")
				{
					this.getFormValues(event.data.data)
				}
			},
			async getFormValues(value)
			{
				this.result = JSON.stringify(value, null, 4);
			},
			async save()
			{
				var data_test = null;
				if (this.type_data_test)
					data_test = await this.$refs.edit_tabulator.save();
				
				return {
					html_form : this.html_form,
					editor: this.editor.getValue(),
					data_test,
					type_data_test: this.type_data_test,
					arr: this.arr
				}
			},
			async load(data)
			{
				this.html_form = data.html_form;
				this.ace_editor.setValue(this.html_form || "", -1);
				this.editor.setValue(data.editor);	
				
				var self = this;
				if (data.type_data_test)
					this.type_data_test = data.type_data_test;

				this.arr = data.arr || [];
					
				self.$nextTick(async function () {

                    if (data.data_test)
                    { 
                        await self.$refs.edit_tabulator.load(data.data_test);
                    }

                });
			},
			update()
			{
				var code = this.editor.getValue()
				if (this.type_data_test)
					this.arr = this.$refs.edit_tabulator.get_data();
				code.before_html += " ";
				this.editor.setValue(code);	
			},
			async get_form()
			{
				return this.editor.getValue();
			},
			async set_form(editor)
			{
				console.log("set_form");
				console.log(editor);
				var e = this.editor.getValue();
				e.title = editor.title;
				e.send = editor.send;
				e.before_html_2 = editor.before_html_2 || "";
				e.after_html_2 = editor.after_html_2 || "";
				if (e.sections.lengh > 0)
					e.sections[0] = editor.sections[0];
				else
					e.sections = editor.sections;
				this.editor.setValue(e);
			}
		},
		mounted: async function () {
			var self = this;

			var ace_editor = ace.edit("ace_editor-" + this.id);
			this.ace_editor = ace_editor;
			ace_editor.session.setMode("ace/mode/html");
			var theme = "chrome";
			if (
				store &&
				store.state &&
				store.state.style &&
				store.state.style.theme &&
				store.state.style.theme.code
			)
				theme = store.state.style.theme.code;
			ace_editor.setTheme("ace/theme/" + theme);
			// enable autocompletion and snippets
			ace_editor.setOptions({
				enableBasicAutocompletion: true,
				enableSnippets: true,
				enableLiveAutocompletion: true,
			});

			var schema = {
				title: "Paramètres",
				type: "object",
				required: ["title", "send", "sections"],
				format: "categories",
				basicCategoryTitle: "Paramètres",
				default: {
					before_html : `
<style>
body {
	background-color: white
}

input[type=text], select, textarea {
  width: 100%;
  padding: 12px 20px;
  margin: 8px 0;
  display: inline-block;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

input[type=submit] {
  width: 100%;
  background-color: #4CAF50;
  color: white;
  padding: 14px 20px;
  margin: 8px 0;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

input[type=submit]:hover {
  background-color: #45a049;
}
</style>
					`
				},
				properties: {
					title: {
						title: "Titre",
						type: "string",
					},
					send: {
						title: "Texte du bouton pour envoyer",
						type: "string",
						default: "Envoyer"
					},
					before_html: {
						title: "HTML au début du formulaire",
						type: "string",
						format: "html",
					},
					after_html: {
						title: "HTML à la fin du formulaire",
						type: "string",
						format: "html"
					},
					before_html_2: {
						title: "HTML au début du formulaire 2",
						type: "string",
						options: {
							hidden: true,
						}
					},
					after_html_2: {
						title: "HTML à la fin du formulaire 2",
						type: "string",
						options: {
							hidden: true,
						}
					},
					sections: {
						title: "Sections",
						type: "array",
						items: {
							title: "section",
							type: "object",
							required: ["title", "fields"],
							properties: {
								title: {
									title: "Titre",
									type: "string",
								},
								before_html: {
									title: "HTML au début de la section",
									type: "string",
									format: "html",
								},
								after_html: {
									title: "HTML à la fin de la section",
									type: "string",
									format: "html"
								},
								attributes: {
									title: "Attributs",
									type: "string"
								},
								fields: {
									type: "array",
									title: "Champs",
									items: {
										title: "Champ",
										type: "object",
										required: ["type"],
										oneOf: [
											{
												title: "Texte",
												required: ["type", "title", "required", "type_field"],
												properties: {
													type: {
														title: "Type",
														type: "string",
														enum: ["texte"],
														options: {
															hidden: true,
														},
													},
													id: {
														title: "Id",
														type: "string",
													},
													name: {
														title: "Nom",
														type: "string",
													},
													title: {
														title: "Label",
														type: "string",
													},
													required: {
														title: "Obligatoire",
														type: "boolean",
														format: "checkbox",
													},
													type_field: {
														title: "Type",
														type: "string",
														enum: ["", "color", "date", "datetime-local", "email", "hidden", "month", "number", "password", "range", "tel", "time", "url", "week"]
													},
													default_value: {
														title: "Valeur par défaut",
														type: "string"
													},
													attributes: {
														title: "Attributs",
														type: "string"
													},
													attributes_div: {
														title: "Attributs div",
														type: "string"
													}
												},
											},
											{
												title: "Fichier",
												required: ["type", "title", "required", "multiple"],
												properties: {
													type: {
														title: "Type",
														type: "string",
														enum: ["file"],
														options: {
															hidden: true,
														},
													},
													id: {
														title: "Id",
														type: "string",
													},
													title: {
														title: "Label",
														type: "string",
													},
													name: {
														title: "Nom",
														type: "string",
													},
													required: {
														title: "Obligatoire",
														type: "boolean",
														format: "checkbox",
													},
													multiple: {
														title: "Multiples fichiers",
														type: "boolean",
														format: "checkbox"
													},
													attributes: {
														title: "Attributs",
														type: "string"
													},
													attributes_div: {
														title: "Attributs div",
														type: "string"
													}
												},
											},
											{
												title: "Texte sur plusieurs colonnes",
												required: ["type", "title", "required"],
												properties: {
													type: {
														title: "Type",
														type: "string",
														enum: ["textarea"],
														options: {
															hidden: true,
														},
													},
													id: {
														title: "Id",
														type: "string",
													},
													title: {
														title: "Label",
														type: "string",
													},
													name: {
														title: "Nom",
														type: "string",
													},
													required: {
														title: "Obligatoire",
														type: "boolean",
														format: "checkbox",
													},
													default_value: {
														title: "Valeur par défaut",
														type: "string"
													},
													attributes: {
														title: "Attributs",
														type: "string"
													},
													attributes_div: {
														title: "Attributs div",
														type: "string"
													}
												},
											},
											{
												title: "Case à cocher",
												required: ["type", "title", "required"],
												properties: {
													type: {
														title: "Type",
														type: "string",
														enum: ["checkbox"],
														options: {
															hidden: true,
														},
													},
													id: {
														title: "Id",
														type: "string",
													},
													name: {
														title: "Nom",
														type: "string",
													},
													title: {
														title: "Label",
														type: "string",
													},
													required: {
														title: "Obligatoire",
														type: "boolean",
														format: "checkbox",
													},
													default_value: {
														title: "Valeur par défaut",
														type: "string"
													},
													attributes: {
														title: "Attributs",
														type: "string"
													},
													attributes_div: {
														title: "Attributs div",
														type: "string"
													}
												},
											},
											{
												title: "Choix unique",
												required: ["type", "title", "values"],
												properties: {
													type: {
														title: "Type",
														type: "string",
														enum: ["radio"],
														options: {
															hidden: true,
														},
													},
													id: {
														title: "Id",
														type: "string",
													},
													name: {
														title: "Nom",
														type: "string",
													},
													title: {
														title: "Label",
														type: "string",
													},
													values: {
														type: "array",
														title: "Valeurs",
														format: "table",
														items: {
															title: "Valeur",
															type: "object",
															required: ["value", "libelle"],
															properties: {
																id: {
																	title: "Id",
																	type: "string",
																},
																value: {
																	title: "Valeur",
																	type: "string",
																},
																libelle: {
																	title: "Libelle",
																	type: "string",
																},
															},
														},
													},
													default_value: {
														title: "Valeur par défaut",
														type: "string"
													},
													attributes: {
														title: "Attributs",
														type: "string"
													},
													attributes_div: {
														title: "Attributs div",
														type: "string"
													},
													attributes_input_div: {
														title: "Attributs div input",
														type: "string"
													}
												},
											},
											{
												title: "Choix multiple",
												required: ["type", "title", "values"],
												properties: {
													type: {
														title: "Type",
														type: "string",
														enum: ["checkboxes"],
														options: {
															hidden: true,
														},
													},
													id: {
														title: "Id",
														type: "string",
													},
													name: {
														title: "Nom",
														type: "string",
													},
													title: {
														title: "Label",
														type: "string",
													},
													values: {
														type: "array",
														title: "Valeurs",
														format: "table",
														items: {
															title: "Valeur",
															type: "object",
															required: ["value", "libelle"],
															properties: {
																id: {
																	title: "Id",
																	type: "string",
																},
																value: {
																	title: "Valeur",
																	type: "string",
																},
																libelle: {
																	title: "Label",
																	type: "string",
																},
															},
														},
													},
													default_value: {
														title: "Valeur par défaut",
														type: "string"
													},
													attributes: {
														title: "Attributs",
														type: "string"
													},
													attributes_div: {
														title: "Attributs div",
														type: "string"
													},
													attributes_input_div: {
														title: "Attributs div input",
														type: "string"
													}
												},
											},
											{
												title: "Liste",
												required: ["type", "title", "values"],
												properties: {
													type: {
														title: "Type",
														type: "string",
														enum: ["list"],
														options: {
															hidden: true,
														},
													},
													id: {
														title: "Id",
														type: "string",
													},
													name: {
														title: "Nom",
														type: "string",
													},
													title: {
														title: "Label",
														type: "string",
													},
													values: {
														type: "array",
														title: "Valeurs",
														format: "table",
														items: {
															title: "Valeur",
															type: "object",
															required: ["value", "libelle"],
															properties: {
																value: {
																	title: "Valeur",
																	type: "string",
																},
																libelle: {
																	title: "Label",
																	type: "string",
																},
															},
														},
													},
													default_value: {
														title: "Valeur par défaut",
														type: "string"
													},
													attributes: {
														title: "Attributs",
														type: "string"
													},
													attributes_div: {
														title: "Attributs div",
														type: "string"
													}
												},
											},
											{
												title: "HTML",
												required: ["type", "html"],
												properties: {
													type: {
														title: "Type",
														type: "string",
														enum: ["html"],
														options: {
															hidden: true,
														},
													},
													html: {
														title: "HTML",
														type: "string",
														format: "html"
													}
												}
											}
										],
									},
								},
							},
						},
					},
				},
			};

			const element = document.getElementById("jsoneditor-" + this.id);
			this.editor = new JSONEditor(element, {
				schema: schema,
				keep_oneof_values: false,
				theme: "bootstrap4",
				iconlib: "fontawesome5",
				object_background: "",
				display_required_only: true
			});

			await new Promise((resolve, reject) => {
				self.editor.on("ready", function () {
					if (resolve) resolve();
				});
			});

			this.editor.on("change", function () {
				var code = "";

				var data = clone(self.editor.getValue());

				console.log(data)

				code = `
${data.before_html_2 || ""}`
				code = `
${data.before_html || ""}`

				if (data.title)
				code+= `
<h3>${data.title}</h3>
            `;

				for (var i = 0; i < data.sections.length; i++) {
					code += `
<div ${data.sections[i].attributes || ""}>
	${data.sections[i].title ? "<h4>" + data.sections[i].title + "</h4>" : ""}
	${data.sections[i].before_html || ""}
                `;
					for (var j = 0; j < data.sections[i].fields.length; j++) {
						var field = data.sections[i].fields[j];

						var required = "";
						if (field.required) 
							required = "required";

						if (!field.name && field.title)
							field.name = removeAccents.remove(field.title.toLowerCase()).replace(/[^a-z0-9_-]+/gi, "_")

						if (!field.id && field.name)
							field.id = field.name.replace(/^[^a-z]+/, "")

						switch (field.type) {
							case "html":
								code +=`
	${field.html}
								`
								break;
							case "texte":
								code += `
	<div ${field.attributes_div || ""}>
		<label for="${field.id}">${field.title}</label>
		<input type="${field.type_field || 'text'}" name="${field.name}" id="${field.id}" ${field.attributes || ""} ${ field.default_value ? 'value="' + field.default_value + '"' : "" } ${required}/>
	</div>
`;
								break;
							case "file":
								code += `
	<div ${field.attributes_div || ""}>
		<label for="${field.id}">${field.title}</label>
		<input type="file" name="${field.name}" id="${field.id}" ${ field.multiple ? "multiple" : "" } ${field.attributes || ""} ${required}/>
	</div>
`;
								break;
							case "textarea":
								code += `
	<div ${field.attributes_div || ""}>
		<label for="${field.id}">${field.title}</label>
		<textarea name="${field.name}" id="${field.id}" ${required} ${field.attributes || ""}>${field.default_value ? field.default_value : ""}</textarea>
	</div>
`;
								break;
							case "checkbox":
								code += `
	<div ${field.attributes_div || ""}>
		<label for="${field.id}">${field.title}</label>
		<input name="${field.name}" id="${field.id}" type="checkbox" ${ field.default_value ? 'checked' : "" } ${required} ${field.attributes || ""}/>
	</div>
`;
								break;
							case "list":
								code += `
	<div ${field.attributes_div || ""}>
		<label for="${field.id}">${field.title}</label>
		<select name="${field.name}" id="${field.id}" ${required} ${field.attributes || ""}>`;
								for (var k = 0; k < field.values.length; k++) {
									
									if (!field.values[k].value)
										field.values[k].value = field.values[k].libelle

									if (!field.values[k].libelle)
										field.values[k].libelle = field.values[k].value

									code += `
			<option value="${field.values[k].value}" ${ field.default_value == field.values[k].value ? 'selected' : "" }>${field.values[k].libelle}</option>`;
								}
								code += `
		</select>
	</div>`;
								break;
							case "radio":
								code += `
	<div ${field.attributes_div || ""}>
		<span >${field.title}</span>`;
								for (var k = 0; k < field.values.length; k++) {
									
									if (!field.values[k].id)
										field.values[k].id = uniqueId("f-")

									if (!field.values[k].value)
										field.values[k].value = field.values[k].libelle

									if (!field.values[k].libelle)
										field.values[k].libelle = field.values[k].value
									
									code += `
				<label for="${field.values[k].id}" ${field.attributes || ""}>${field.values[k].libelle}</label>
				<input type="radio" name="${field.name}" value="${field.values[k].value}" id="${field.values[k].id}" ${ field.default_value == field.values[k].value ? 'checked' : "" } ${field.attributes || ""}>
			`;
								}
								code += `
	</div>`;
								break;
							case "checkboxes":
								code += `
	<div ${field.attributes_div || ""}>
		<span>${field.title}</span>`;
								for (var k = 0; k < field.values.length; k++) {
									
									if (!field.values[k].id)
										field.values[k].id = uniqueId("f-")

									if (!field.values[k].value)
										field.values[k].value = field.values[k].libelle

									if (!field.values[k].libelle)
										field.values[k].libelle = field.values[k].value

									code += `
			<label for="${field.values[k].id}" ${field.attributes || ""}>${field.values[k].libelle}</label>
			<input type="checkbox" name="${field.name}" value="${field.values[k].value}" id="${field.values[k].id}" ${ field.default_value == field.values[k].value ? 'checked' : "" } ${field.attributes || ""} >
		`;
								}
								code += `
	</div>`;
								break;
						}
					}
					code += `
</div>
${data.sections[i].after_html || ""}
					`
				}

				if (data.send)
					code += `
<input type="submit" value="${data.send}">`

				code += `
${data.after_html || ""}`
				code += `
${data.after_html_2 || ""}`

				self.$emit("update", code);

				var compiled = __.template(code);
				code = compiled({ data: self.arr.length > 0 ? self.arr[0]: {}, moment });
				code = code.replaceAll("c41bd1e2-2c96-4966-8d98-ac0f053f340e", "${");
						
				self.ace_editor.setValue(code, -1);
				self.html_form = code;
			});

			window.addEventListener('message', this.receiveMessage)
		},
		beforeDestroy () {
			window.removeEventListener('message', this.receiveMessage)
		}
	};
</script>
